// Bilingual UI strings for DevTask. Keys are dotted paths, resolved by t() in useI18n.
export const messages = {
  he: {
    common: {
      save: 'שמירה', saveChanges: 'שמירת שינויים', create: 'יצירה', cancel: 'ביטול',
      saving: 'שומר…', edit: 'עריכה', reset: 'איפוס', search: 'חיפוש…',
      all: 'הכל', none: '— ללא —', viewAll: 'הצג הכל', loading: 'טוען…',
    },
    nav: {
      dashboard: 'לוח בקרה', myTasks: 'המשימות שלי', teamTasks: 'משימות צוות',
      projects: 'פרויקטים', archive: 'ארכיון', clients: 'לקוחות', signOut: 'התנתקות',
      language: 'English', theme: 'מצב תצוגה',
    },
    roles: { client: 'לקוח', manager: 'מנהל', developer: 'מפתח' },
    login: {
      title: 'התחברות למרחב העבודה',
      sub: 'אין לך חשבון? פנה למנהל כדי לקבל גישה.',
      identifier: 'אימייל או שם משתמש',
      identifierPlaceholder: 'you@company.com או שם המשתמש שלך',
      password: 'סיסמה',
      signIn: 'התחברות',
      signingIn: 'מתחבר…',
      failed: 'ההתחברות נכשלה',
    },
    dashboard: {
      morning: 'בוקר טוב', afternoon: 'צהריים טובים', evening: 'ערב טוב',
      there: 'שלום',
      sub: 'הנה מה שעל הפרק היום',
      newTask: 'משימה חדשה',
      open: 'פתוחות', inProgress: 'בתהליך', done: 'הושלמו', critical: 'דחופות',
      recentTasks: 'משימות אחרונות',
      empty: 'אין משימות עדיין. צור את הראשונה!',
    },
    tasks: {
      myTitle: 'המשימות שלי', teamTitle: 'משימות צוות',
      mySub: 'משימות שהוקצו לך או שיצרת', teamSub: 'כל המשימות הגלויות לצוות שלך',
      newTask: 'משימה חדשה',
      allUrgency: 'כל הדחיפויות', allProjects: 'כל הפרויקטים',
      empty: 'לא נמצאו משימות.',
      archiveConfirm: 'להעביר את "{title}" לארכיון?',
    },
    taskForm: {
      newTask: 'משימה חדשה', editTask: 'עריכת משימה',
      title: 'כותרת', titlePlaceholder: 'כותרת המשימה',
      description: 'תיאור', descriptionPlaceholder: 'פרטים נוספים…',
      urgency: 'דחיפות', status: 'סטטוס', project: 'פרויקט', dueDate: 'תאריך יעד',
      visibility: 'נראות',
      shared: '🌐 משותף (הצוות רואה)', private: '🔒 פרטי (רק אתה + המוקצה)',
      assignTo: 'הקצה ל', unassigned: '— לא מוקצה —',
      linkClient: 'קישור ללקוח',
      createTask: 'צור משימה', saveFailed: 'השמירה נכשלה',
    },
    taskCard: { private: 'פרטי', markDone: 'סמן כהושלם', reopen: 'פתח מחדש', archive: 'ארכיון' },
    timer: { start: 'הפעל טיימר', stop: 'עצור טיימר' },
    urgency: { low: 'נמוכה', normal: 'רגילה', high: 'גבוהה', critical: 'דחופה' },
    status: { open: 'פתוחה', in_progress: 'בתהליך', done: 'הושלמה' },
    projects: {
      title: 'פרויקטים', newProject: 'פרויקט חדש', editProject: 'עריכת פרויקט',
      empty: 'אין פרויקטים עדיין.',
      name: 'שם', description: 'תיאור', color: 'צבע', visibility: 'נראות',
      shared: 'משותף (הצוות רואה)', private: 'פרטי (רק אתה)',
      sharedBadge: 'משותף', privateBadge: 'פרטי',
      taskCountOne: 'משימה פתוחה אחת', taskCountMany: 'משימות פתוחות',
      viewTasks: 'הצג משימות', archiveTitle: 'העבר פרויקט לארכיון',
      archiveConfirm: 'להעביר את הפרויקט "{name}" לארכיון?',
      members: 'חברי הפרויקט', addMember: 'הוסף', remove: 'הסר',
      noMembers: 'אין חברים עדיין', selectUser: '— בחר משתמש —',
      membersHint: 'חברים יכולים לראות את הפרויקט וליצור בו משימות',
      saveFirst: 'שמור את הפרויקט תחילה כדי להוסיף חברים',
    },
    archive: {
      title: 'ארכיון', sub: 'כל המשימות בארכיון — שום דבר לא נמחק לצמיתות',
      tasks: 'משימות', projects: 'פרויקטים',
      noTasks: 'אין משימות בארכיון.', noProjects: 'אין פרויקטים בארכיון.',
      archivedOn: 'הועבר לארכיון',
      restore: 'שחזור', restoreConfirm: 'לשחזר את "{title}" מהארכיון?',
    },
    clients: {
      title: 'לקוחות', sub: 'לקוחות חיצוניים שיכולים לצפות במשימות ששותפו איתם',
      addClient: 'הוסף לקוח', editClient: 'עריכת לקוח',
      name: 'שם', username: 'שם משתמש', status: 'סטטוס',
      active: 'פעיל', inactive: 'לא פעיל',
      activate: 'הפעל', deactivate: 'השבת',
      empty: 'אין לקוחות חיצוניים עדיין.',
      fullName: 'שם מלא', usernamePlaceholder: 'ללא רווחים, משמש להתחברות',
      newPassword: 'סיסמה חדשה (השאר ריק לשמירה)', passwordLabel: 'סיסמה',
      passwordPlaceholder: 'לפחות 8 תווים',
      toggleConfirm: '{verb} את {name}?',
    },
  },
  en: {
    common: {
      save: 'Save', saveChanges: 'Save changes', create: 'Create', cancel: 'Cancel',
      saving: 'Saving…', edit: 'Edit', reset: 'Reset', search: 'Search…',
      all: 'All', none: '— None —', viewAll: 'View all', loading: 'Loading…',
    },
    nav: {
      dashboard: 'Dashboard', myTasks: 'My Tasks', teamTasks: 'Team Tasks',
      projects: 'Projects', archive: 'Archive', clients: 'Clients', signOut: 'Sign out',
      language: 'עברית', theme: 'Theme',
    },
    roles: { client: 'Client', manager: 'Manager', developer: 'Developer' },
    login: {
      title: 'Sign in to your workspace',
      sub: 'No account? Contact your manager to get access.',
      identifier: 'Email or username',
      identifierPlaceholder: 'you@company.com or your.username',
      password: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      failed: 'Login failed',
    },
    dashboard: {
      morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening',
      there: 'there',
      sub: "Here's what's on your plate today",
      newTask: 'New Task',
      open: 'Open', inProgress: 'In Progress', done: 'Done', critical: 'Critical',
      recentTasks: 'Recent Tasks',
      empty: 'No tasks yet. Create your first one!',
    },
    tasks: {
      myTitle: 'My Tasks', teamTitle: 'Team Tasks',
      mySub: 'Tasks assigned to or created by you', teamSub: 'All tasks visible to your team',
      newTask: 'New Task',
      allUrgency: 'All urgency', allProjects: 'All projects',
      empty: 'No tasks found.',
      archiveConfirm: 'Archive "{title}"? It will move to the archive.',
    },
    taskForm: {
      newTask: 'New Task', editTask: 'Edit Task',
      title: 'Title', titlePlaceholder: 'Task title',
      description: 'Description', descriptionPlaceholder: 'Optional details…',
      urgency: 'Urgency', status: 'Status', project: 'Project', dueDate: 'Due date',
      visibility: 'Visibility',
      shared: '🌐 Shared (team sees this)', private: '🔒 Private (only you + assignee)',
      assignTo: 'Assign to', unassigned: '— Unassigned —',
      linkClient: 'Link to client',
      createTask: 'Create task', saveFailed: 'Save failed',
    },
    taskCard: { private: 'Private', markDone: 'Mark as done', reopen: 'Reopen', archive: 'Archive' },
    timer: { start: 'Start timer', stop: 'Stop timer' },
    urgency: { low: 'Low', normal: 'Normal', high: 'High', critical: 'Critical' },
    status: { open: 'Open', in_progress: 'In Progress', done: 'Done' },
    projects: {
      title: 'Projects', newProject: 'New Project', editProject: 'Edit Project',
      empty: 'No projects yet.',
      name: 'Name', description: 'Description', color: 'Color', visibility: 'Visibility',
      shared: 'Shared (team sees this)', private: 'Private (only you)',
      sharedBadge: 'Shared', privateBadge: 'Private',
      taskCountOne: 'open task', taskCountMany: 'open tasks',
      viewTasks: 'View tasks', archiveTitle: 'Archive project',
      archiveConfirm: 'Archive project "{name}"? It will no longer appear in the project list.',
      members: 'Project members', addMember: 'Add', remove: 'Remove',
      noMembers: 'No members yet', selectUser: '— Select user —',
      membersHint: 'Members can see the project and create tasks in it',
      saveFirst: 'Save the project first to add members',
    },
    archive: {
      title: 'Archive', sub: 'All archived tasks — nothing is permanently deleted',
      tasks: 'Tasks', projects: 'Projects',
      noTasks: 'No archived tasks.', noProjects: 'No archived projects.',
      archivedOn: 'Archived',
      restore: 'Restore', restoreConfirm: 'Restore "{title}" from the archive?',
    },
    clients: {
      title: 'Clients', sub: 'External clients who can view tasks shared with them',
      addClient: 'Add Client', editClient: 'Edit Client',
      name: 'Name', username: 'Username', status: 'Status',
      active: 'Active', inactive: 'Inactive',
      activate: 'Activate', deactivate: 'Deactivate',
      empty: 'No external clients yet.',
      fullName: 'Full name', usernamePlaceholder: 'no spaces, used to log in',
      newPassword: 'New password (leave blank to keep)', passwordLabel: 'Password',
      passwordPlaceholder: 'min 8 characters',
      toggleConfirm: '{verb} {name}?',
    },
  },
}
